<template>
  <div class="sub-header-1">
    <h2 v-html="title"></h2>
    <div class="updated-date" v-if="updated">Last Updated: {{ updated }}</div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
    updated: {
      type: String,
    },
  },
}
</script>

<style scoped>
/*.sub-header-1{
    padding:15px;
    font-size:20px;
    font-weight:bold;
    text-align:center;
    color:#009933;
    text-transform:uppercase;
    letter-spacing: 2px;
    font-family: 'Open Sans Condensed', sans-serif;
    background:#000;
    margin-bottom:30px;
  }*/
</style>
